export default __webpack_public_path__ + "img/66f741834ad95ef30a6268d4fa00020e.svg";